import React, { useEffect, useState } from "react";
import Button from "../../../form/Button";
import { useMutation } from "@tanstack/react-query";
import { organizationAddEdit } from "../../../../services/organizationService";
import { toast } from "react-toastify";
import Input from "../../../form/Input";
import Select from "../../../form/select/Select";
import { useTranslation } from "react-i18next";

const ContactPref = ({ data = {}, organizationDetailsRefetch = () => {} }) => {
  const { t } = useTranslation();
  const [contactType, setContactType] = useState("sameaccount");
  const [contactEmail, setContactEmail] = useState("");

  useEffect(() => {
    setContactType(data?.contactType || "sameaccount");
    setContactEmail(data?.contactEmail);
  }, [data]);

  const { mutate: handleSave, isPending } = useMutation({
    mutationFn: async (value) => {
      const res = await organizationAddEdit({
        ...(data?._id && { id: data?._id }),
        contactType,
        ...(contactType === "different" && {
          contactEmail,
        }),
      });
      return res;
    },
    onSuccess: (res) => {
      if (res?.status === 200 || res?.status === 201) {
        organizationDetailsRefetch();
      } else {
        toast.error(res?.message || res?.error);
      }
    },
  });

  return (
    <div className="mx-auto p-4 bg-white shadow rounded-md">
      <div className="py-4 md:py-8 px-3 md:px-6 rounded-md space-y-4 border border-gray-200">
        <h2 className="text-xl md:text-2xl text-deep-purple font-bold font-Montserrat mb-2">
          {t("Customer contact preferences")}
        </h2>

        <div className="pb-4 space-y-4">
          <Select
            dropdownButtonClass={
              "rounded-md text-deep-purple !font-medium !h-12 !bg-surface-04 !border-surface-05"
            }
            label={t(
              "Where should contact form submissions and replies to ticket emails go?"
            )}
            selectedValue={contactType}
            dropdownData={[
              { value: "sameaccount", name: t("To my account email address") },
              { value: "different", name: t("To a different email address") },
            ]}
            onChange={setContactType}
          />
          {contactType === "different" && (
            <Input
              label={
                "Please enter the email address for customer contact enquiries"
              }
              type="text"
              value={contactEmail}
              onChange={(e) => setContactEmail(e.target.value)}
              className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              inputClasses={
                "rounded-md text-deep-purple !font-medium !h-12 !bg-surface-04 !border-surface-05"
              }
            />
          )}
        </div>

        <div className="mt-4 flex justify-end">
          <Button
            buttonFunction={handleSave}
            className="bg-green-500 hover:bg-green-600 text-white font-semibold px-6 py-2 rounded-full transition"
            buttonLabel={t("Save")}
            {...(isPending && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
        </div>
      </div>
    </div>
  );
};

export default ContactPref;
